import {
    Grid, // our UI Component to display the results
    SearchBar, // the search bar the user will type into
    SearchContext, // the context that wraps and connects our components
    SearchContextManager, // the context manager, includes the Context.Provider
} from '@giphy/react-components'
import {useContext} from "react";
import {Flex} from "@instructure/ui-flex";
import {Link} from "@instructure/ui-link";
import {Img} from "@instructure/ui-img";

// the search experience consists of the manager and its child components that use SearchContext
const SearchExperience = (props) => (
    <SearchContextManager apiKey='l5khVjp277Rrc93JO2CiCXbxgn9dYt40'>
        <Components onGifClick={props.onGifClick}/>
    </SearchContextManager>
)

// define the components in a separate function so we can
// use the context hook. You could also use the render props pattern
const Components = (props) => {
    const {fetchGifs, searchKey} = useContext(SearchContext)
    return (
        <>
            <Flex alignItems='top'>
                <Flex.Item shouldGrow shouldShrink padding='none small'>
                    <SearchBar/>
                </Flex.Item>
                <Flex.Item>
                    <Link href='https://giphy.com/' target='_blank'>
                    <Img src="./giphy-logo.gif" width="200" alt="Powered by GIPHY"/>
                    </Link>
                </Flex.Item>
            </Flex>
            {/**
             key will recreate the component,
             this is important for when you change fetchGifs
             e.g. changing from search term dogs to cats or type gifs to stickers
             you want to restart the gifs from the beginning and changing a component's key does that
             **/}
            {/* TODO Need to get the width of the content frame and set this. */}
            <Grid key={searchKey} columns={3} width={800} fetchGifs={fetchGifs} noLink hideAttribution
                  onGifClick={props.onGifClick}/>
        </>
    )
}

export default SearchExperience